module.exports = __webpack_public_path__ + "static/media/student-snapshort2-gameplay.51fcf226.png";